import { render } from "./order-details.vue?vue&type=template&id=6d519dc4"
import script from "./order-details.vue?vue&type=script&lang=js"
export * from "./order-details.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__